import {OrbitControlConstraint} from './OrbitControlConstraint';

export class RoofConstraint extends OrbitControlConstraint {

  private maxY: number;

  constructor(maxY: number) {
    super();
    this.maxY = maxY;
  }

  check(camera, newPosition): boolean {
    return newPosition.y <= this.maxY;
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/orbitControlConstraint/RoofConstraint.ts